module.exports = __webpack_public_path__ + "img/strategy_sj.24b3d899.svg";